import React, { useState, useEffect } from "react";
import {
  GetClassesBySchoolId,
  GetProgrammesBySchoolId,
  GetFortnoxPrograms,
} from "../../actions/adminQueries";
import { Button, Row, Col, Input, Table, Card, CardTitle } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditProgramme from "../../components/Modal/EditProgramme";
import CreateProgramme from "../../components/Modal/CreateProgramme";
import { API_BASE_URL } from "../../constants/api.constants";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "../../services/api/api";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";
import { useLocation } from "react-router-dom";
import useRedirectIf from "../../hooks/useRedirectIf";

function Programmes() {
  const intl = useIntl();
  const location = useLocation();
  const [school] = useState(
    location.state
      ? location.state.school
      : JSON.parse(localStorage.getItem("school"))
  );
  const [createProgrammeModal, setCreateProgrammeModal] = useState(false);
  const [overrideLoader, setOverrideLoader] = useState(false);
  const [programmes, setProgrammes] = useState([]);
  const [programmeToUpdate, setProgrammeToUpdate] = useState(null);
  const [programmeToRemove, setProgrammeToRemove] = useState(null);
  const [displayConfirmDialog, setDisplayConfirmDialog] = useState(false);
  const [programmeEditModal, setProgrammeEditModal] = useState(false);

  const programmesQuery = GetProgrammesBySchoolId(school?.id);
  const classesQuery = GetClassesBySchoolId(school?.id);
  const fortNoxPrograms = GetFortnoxPrograms();

  useRedirectIf("/superuser/schools", !school);

  useEffect(() => {
    localStorage.setItem("school", JSON.stringify(school));
  }, [school]);

  useEffect(() => {
    if (!programmesQuery.isPending && programmesQuery.data) {
      setProgrammes(programmesQuery.data);
    }
  }, [programmesQuery.data, programmesQuery.isPending]);

  const loadProgrammes = () => {
    setOverrideLoader(true);
    programmesQuery.refetch();
  };

  const toggleProgrammeModal = () => {
    setCreateProgrammeModal(!createProgrammeModal);
  };

  const handleSetProgrammeToUpdate = (programme) => {
    setProgrammeToUpdate(programme);
    setProgrammeEditModal(true);
  };

  const toggleEditModal = () => {
    setProgrammeToUpdate(null);
    setProgrammeEditModal(!programmeEditModal);
  };

  const toggleCreateProgrammeModal = () => {
    setCreateProgrammeModal(!createProgrammeModal);
  };

  const toggleConfirmDialog = (p) => {
    setProgrammeToRemove(p);
    setDisplayConfirmDialog(!displayConfirmDialog);
  };

  const reloadProgrammes = () => {
    programmesQuery.refetch();
  };

  const getprogrammeToRemove = () => {
    if (programmeToRemove) {
      let c = programmes.find((c) => c.id === programmeToRemove.id);
      if (c) return c.name;
    }
    return intl.formatMessage({ id: "Unknown" });
  };

  const handleFilterSearch = (event) => {
    setProgrammes(
      programmesQuery.data.filter((p) => {
        if (p.name.toLowerCase().indexOf(event.target.value) !== -1) {
          return p;
        }
        return null;
      })
    );
  };

  const deleteProgramme = () => {
    axios
      .delete(`${API_BASE_URL}/programme/${programmeToRemove.id}`)
      .then(() => {
        reloadProgrammes();
        setProgrammeToRemove(null);
        setDisplayConfirmDialog(false);
        toast.success(
          <FormattedMessage id="Views.Admin.DeleteProgramFromSchool.Success" />,
          TOAST_CONFIG
        );
      })
      .catch((err) => {
        toast.error(
          formatServiceError(intl, err?.response?.data),
          TOAST_CONFIG,
        );
      });
  };

  if (!school) {
    return null;
  }

  if (programmesQuery.isPending && overrideLoader === false) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  var mappedProgrammes = programmes.map((p, id) => {
    return (
      <tr key={id}>
        <td className="text-center">{p.id}</td>
        <td>
          <Button color="link" onClick={() => handleSetProgrammeToUpdate(p)}>
            {p.name}
          </Button>
        </td>
        <td className="text-end">{p.classes.length}</td>
        <td>
          <Button
            onClick={(e) => {
              toggleConfirmDialog(p);
              e.stopPropagation();
            }}
            size="sm"
            color="danger"
            outline
            className="float-end"
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <div className="animated fadeIn">
      <Row>
        <Col lg="12">
          <Card body>
            <CardTitle>
              <FormattedMessage id="ProgramAtSchool" values={{ school: school.name }} />
            </CardTitle>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card body>
            <Row className="search-row">
              <Col className="col-4">
                <Input
                  className="search-input"
                  placeholder={intl.formatMessage({ id: "SearchProgram" })}
                  onChange={(data) => handleFilterSearch(data)}
                />
              </Col>
              <Col className="offset-6 col-2">
                <Button
                  className="float-end"
                  color="primary"
                  outline
                  onClick={() => {
                    toggleProgrammeModal();
                  }}
                >
                  <FontAwesomeIcon icon="plus" />
                </Button>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <Table hover className="school-table clickable">
                  <thead>
                    <tr>
                      <th className="text-center">Id</th>
                      <th><FormattedMessage id="Name" /></th>
                      <th className="text-end"><FormattedMessage id="ClassesNumberOf" /></th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>{mappedProgrammes}</tbody>
                </Table>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <CreateProgramme
        toggle={toggleCreateProgrammeModal}
        isOpen={createProgrammeModal}
        onComplete={loadProgrammes}
        school={school}
        fortNoxPrograms={fortNoxPrograms.data || []}
      />

      <EditProgramme
        toggle={toggleEditModal}
        isOpen={programmeEditModal}
        onComplete={loadProgrammes}
        programme={programmeToUpdate}
        classes={classesQuery.data || []}
      />

      <ConfirmDialog
        isOpen={displayConfirmDialog}
        danger={true}
        title={<FormattedMessage id="RemoveProgram" />}
        message={
          <div>
            <p>
              <FormattedMessage
                id="AreYouSureRemoveProgramNamed"
                values={{ name: <strong>{getprogrammeToRemove()}</strong> }}
              />
            </p>
            <p>
              <em>
                <FormattedMessage id="ChoiceCannotBeUndone" />
              </em>
            </p>
          </div>
        }
        toggle={toggleConfirmDialog}
        onProceed={deleteProgramme}
      />
    </div>
  );
}

export default Programmes;
